<template>
<!-- <e-child-layout root="/vcard/detail" style="height:100%;width:100%;"  @message="messageHandle"> -->
<!-- <div>{{debugerMes}}</div> -->
<div style="background:#fff;padding:0 16px;">
   <div class="type-1 flex-center">
      <div>
        <img class="avatar" :src="posterData.avatar" />
      </div>
      <div style="padding-left: 12px;">
        <div class="t-name flex-center">
          <span class="van-ellipsis name-left">{{ posterData.name }}</span>
          <span>{{ posterData.position }}</span>
          <img
            src="https://img.esenyun.com/images/20200813/6c150633d2874b18a09d165f3aef3c38.png"
            style="width: 12px;height: 12px;margin-left :2px;"
          />
        </div>
        <div class="t-sub">联系服务顾问，了解更多</div>
      </div>
      <div
        class="flex-center"
        style="flex: 1;justify-content:flex-end;margin-right: 20px;"
      >
        <div class="opt-icon flex-center" @click="makePhone">
          <img
            src="https://img.esenyun.com/images/20200602/542b83e4257c4030acb64662b7a6de41.png"
          />
        </div>
      </div>
      <div class="opt-icon flex-center" @click="clickshowVcard">
        <img
          src="https://img.esenyun.com/images/20200602/0a45d8d030f84ff2b7274ac7fb8db648.png"
        />
      </div>
    </div>
  <div v-if="posterData&&showVcard">
    <VCardNew
          :posterData="posterData"
          :eacrdImg="eacrdImg"
          @showMark="()=>showVcard=false"
          @imgOK="onImgOK"
    ></VCardNew>
  </div>
  <div class="showimg flex-column" style="margin-bottom:20px" v-if="show" @click="hide($event)">
    <div style="text-align:right;margin-bottom:20px">
      <img @click="hide($event)" class="img" src="../assets/x.svg" />
    </div>
    <div class="img"><img class="vard-img" :src="img" /></div>
    <div class="tips">长按名片图片保存到手机/分享</div>
  </div>
  </div>
</template>
<script>
import VCardNew from "@/components/VCardNew"
export default {
   components: {
    VCardNew,
  },
  props: ['posterData', 'disabled'],
  data(){
    return {
      showVcard:false,
      show:false,
      eacrdImg:""
    }
  },
  mounted(){
  },
  methods:{
    hide(e){
      e.cancelBubble = true
      e.stopPropagation()
      this.show=false
    },
    makePhone() {
      window.location.href = `tel:${this.posterData.mobile}`
    },
    // 海报生成成功
    onImgOK(img) {
      console.log('----------------------')
      this.eacrdImg=img
      this.$emit('ok', img)
    },
     clickshowVcard(){
      this.showVcard = true
      this.$emit('showMark',false)
    }
  }
}
</script>
<style lang="less" scoped>
.flex-column {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  align-content:center;
}
.flex-row {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.vard-detail-box{
  position: relative;
  height:100%;
  width:100%;
}
.vard-detail{
  position: relative;
  height:100%;
  width:100%;
  overflow: auto;
  .body{
    position: relative;
    flex-grow:1;
    padding:0px 16px;
    overflow: auto;
    padding-bottom:40px;
    .avatar-edit{
      position:absolute;
      right:41px;
      top:77px;
      width:24px;
      height:24px;
      z-index: 1;
    }
    .title{
      position: relative;
      font-family: PingFang SC;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
      margin:12px 0px 12px 0px;
      color: #323233;
    }
    .title::before{
      content: ' ';
      position: relative;
      display: inline-block;
      height:18px;
      width: 4px;
      border-radius: 5px;
      background:#1F7DDE;
      margin-right:4px;
      top:2px;
    }
    .card{
      background: #FFFFFF;
      border-radius: 3px;
      padding:20px;
      margin-top:16px;
      .item{
        .item-title{
          font-size: 16px;
          color: #000000;
          text-align: left;
        }
        .item-conent{
          font-size: 16px;
          color: #7D7E80;
          text-align: right;
        }
      }
    }
  }
}
.vard-detail-drow{
  background:rgba(0, 0, 0, 0);
  // background: #000000;
}
.vcard{
  background: #FFFFFF;
  border-radius: 5px;
  padding:20px;
  .info{
    position: relative;
    width:100%;
    max-height:350px;
    overflow: hidden;
    // .img{
    //   width: 100%;
    // }
    .avatar-img{
      position: relative;
      width:100%;
      height:350px;
      overflow: hidden;
      background-color: #ccc;
    }
    .avatar-img img{
      position:absolute;
      height: 350px;
      min-width: 200px;
      width: auto;
      left:50%;
      top:0px;
      transform: translateX(-50%);
    }
    .user-info{
      position:absolute;
      bottom: 28px;
      left:20px;
      padding:12px 16px;
      background: rgba(0, 0, 0, 0.4);
    }
    .user-name{
      font-weight: 500;
      font-size: 28px;
      color: #FFFFFF;
      padding:0px;
      margin:0px;
      flex-grow: 0;
      flex-shrink: 0;
      img{
        padding:0px;
        margin:0px;
      }
    }
    .user-position{
      flex-grow: 0;
      font-weight: 500;
      font-size: 16px;
      color: #FFFFFF;
    }
    .user-company{
      flex-grow: 0;
      font-weight: 500;
      font-size: 16px;
      color: #FFFFFF;
    }
  }
  .line{
    opacity: 0.8;
    height: 16px;
    margin-bottom:16px;
    border-bottom: 1px dashed #DCDDE0;
    box-sizing: border-box;
  }
  .qcode{
    width: 100%;
    height:80px;
    margin-top:10px;
    .tip{
      font-size: 16px;
      color: #000000;
      line-height: 25px;
    }
  }
}

.showimg{
  position:fixed;
  left: 0px;
  top:0px;
  height:100%;
  width: 100%;
  z-index: 2;
  background: rgba(0, 0, 0, 0.8);
  padding:20px;
  .img{
    flex-grow: 1;
    text-align: center;
    img{
       width: 90%;
    }
  }
  .tips{
    flex-grow: 0;
    flex-shrink: 0;
    text-align: center;
    line-height:120px;
    font-size:1.1rem;
    color:#fff;
  }
  .btns{
    flex-grow: 0;
    width: 100%;
    text-align: center;
    justify-content:center;
    .btny{
      display:inline-block;
      border: none;
      background: #F9E14C;
      border-radius: 50px;
      font-size: 16px;
      color: #323233;
      width: 55%;
    }
    .btnb{
      display:inline-block;
      border: none;
      background: linear-gradient(270deg, #306FE2 24.05%, #1F7DDE 73.62%);
      border-radius: 50px;
      font-size: 16px;
      color: #FFFFFF;
      width: 55%;
    }
  }
}
.forward_text {
  padding: 24px 0 16px 0;
  color: #000;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  .arrow {
    display: inline-block;
    width: 0;
    height: 0;
    border-top: 8px solid #7d7e80;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    margin: 0 6px;
  }
}
.show_vcard {
  height: 218px;
  margin-top: 56px;
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
  background: #fff;
  border-radius: 5px;
  .title {
    position: relative;
    height: 138px;
    background: url('https://img.esenyun.com/images/20200602/1da422ddd2e641f697d619590d9340dd.png')
      no-repeat;
    background-size: 100%;
    .logo {
      text-align: center;
      position: relative;
      height: 38px;
      top: -30%;
      .logo-container {
        width: 76px;
        height: 76px;
        display: inline-block;
        border-radius: 50%;
        // margin-top: -38px;
        border: 4px solid #fff;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .name {
    margin-top: 12px;
    text-align: center;
    font-size: 20px;
    line-height: 28px;
    color: #fff;
  }
  .sub {
    font-size: 14px;
    line-height: 22px;
    color: #fff;
    margin-top: 7px;
    text-align: center;
  }
  .phone {
    font-size: 20px;
    line-height: 24px;
    margin-left: 20px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 4px;
    }
  }
  .opt-icon {
    width: 40px;
    height: 40px;
    justify-content: center;
    margin-right: 20px;
    text-align: center;
    border-radius: 50%;
    background: #ebf2ff;
    img {
      width: 20px;
      height: 20px;
    }
  }
}
.opt-icon {
  width: 40px;
  height: 40px;
  justify-content: center;
  text-align: center;
  border-radius: 50%;
  background: #ebf2ff;
  img {
    width: 20px;
    height: 20px;
  }
}
.type-1 {
  height: 64px;
  font-size: 14px;
  .avatar {
    border: 1px solid #dcdde0;
    width: 46px;
    height: 46px;
    border-radius: 50%;
  }
  .t-name {
    line-height: 22px;
    .name-left {
      max-width: 100rpx;
      margin-right: 4px;
    }
  }
  .t-sub {
    font-size: 12px;
    line-height: 20px;
    color: #7d7e80;
  }
}

</style>